import React from 'react';
import { Card, Typography, Input, Alert, Space, Tag } from 'antd';
import { LinkOutlined, GlobalOutlined } from '@ant-design/icons';

const { Text, Paragraph } = Typography;

/**
 * Banner de configuración de incrustación externa.
 *
 * Solo renderiza si el toggle del header está en ON. Muestra el input para la
 * URL pública + validación. El toggle SI/NO vive en el header de Micrositio.jsx.
 */
const EmbedExternoBanner = ({ config, onChange }) => {
  const url = config.url_embed_publico || '';
  const urlTrim = url.trim();

  const handleUrlChange = (e) => {
    onChange('url_embed_publico', e.target.value);
  };

  const isParseable = () => {
    if (!urlTrim) return true;
    try {
      const u = new URL(urlTrim);
      return u.protocol === 'https:' || u.protocol === 'http:';
    } catch {
      return false;
    }
  };

  const urlInvalida = urlTrim && !isParseable();
  const urlHttp = urlTrim && isParseable() && urlTrim.startsWith('http://');

  return (
    <Card
      style={{ marginBottom: 16, borderColor: '#d4a017' }}
      styles={{ body: { padding: '16px 20px' } }}
    >
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <Text strong>
          <LinkOutlined /> &nbsp;URL pública donde lo vas a embeber
        </Text>

        <Paragraph type="secondary" style={{ marginBottom: 4, fontSize: 13 }}>
          Esta URL se usa para los <strong>links de share por WhatsApp</strong>{' '}
          y para los <strong>enlaces de los animales en el PDF</strong>, así el
          tráfico va a <strong>tu dominio</strong> en vez de a{' '}
          <code>puja.com.ar</code>.
        </Paragraph>

        <Input
          value={url}
          onChange={handleUrlChange}
          placeholder="https://remates.cabanapilaga.com.ar/"
          status={urlInvalida ? 'error' : ''}
          addonBefore={<GlobalOutlined />}
          allowClear
          style={{ maxWidth: 600 }}
        />

        {urlInvalida && (
          <Alert
            type="error"
            showIcon
            message="URL inválida. Tiene que ser una dirección parseable (ej: https://remates.cabanapilaga.com.ar/)."
          />
        )}

        {urlHttp && (
          <Alert
            type="warning"
            showIcon
            message="Recomendamos usar HTTPS por seguridad. Cambiá http:// por https://."
          />
        )}

        <Paragraph type="secondary" style={{ marginTop: 4, fontSize: 12, marginBottom: 0 }}>
          <Tag color="gold" style={{ marginRight: 8 }}>ℹ️ Tip</Tag>
          Si querés que los links vuelvan a apuntar a PUJA, simplemente apagá el toggle de arriba.
        </Paragraph>
      </Space>
    </Card>
  );
};

export default EmbedExternoBanner;
